import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import config from '../config/config';
import { getAuth } from "firebase/auth" 
import { getFirestore } from "firebase/firestore";
// New import

let app: FirebaseApp;

if (getApps().length === 0) {
	// Initialize Firebase
	 app = initializeApp(config.firebase);
} else {
	// else return what we already have
	app = getApps()[0];
}


export const auth = getAuth(app);
export default app;
export const db = getFirestore(app);